import { HomeVariantOutlineIcon } from './HomeVariantOutlineIcon';

/**
 * author: Google
 * id 5DF1214D-79EC-4EA0-B435-CB73B877DCA9
 * name home-variant-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseVariantOutlineIcon = HomeVariantOutlineIcon;
export default HouseVariantOutlineIcon